import { Fragment as _Fragment } from "react/jsx-runtime";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from "react";
import { baseComponents } from "~components/markdown";
import meta from "~generated/meta.json";
import { Box, Container, Heading, Link, List, ListItem, SimpleGrid, Stack, Text, useColorModeValue } from "@chakra-ui/react";
import trimHttps from "@grikomsn/shared/utils/trim-https";
import { NextSeo } from "next-seo";
import { Image } from "react-datocms";
import ReactMarkdown from "react-markdown";
var pageMeta = {
  title: "About me",
  description: "Get to know more about myself"
};

var AboutPage = function AboutPage(props) {
  var _data$about, _data$about$coverImag, _data$about2, _data$about3, _data$about3$knowledg;

  var data = props.data;
  var variant = useColorModeValue("dark", "light");
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NextSeo, _objectSpread({}, pageMeta)), /*#__PURE__*/_jsxs(Container, {
      maxW: "4xl",
      p: [4, 8],
      children: [/*#__PURE__*/_jsx(Box, {
        pb: 8,
        children: /*#__PURE__*/_jsx(Image, {
          data: (_data$about = data.about) === null || _data$about === void 0 ? void 0 : (_data$about$coverImag = _data$about.coverImage) === null || _data$about$coverImag === void 0 ? void 0 : _data$about$coverImag.responsiveImage
        })
      }), /*#__PURE__*/_jsx(Stack, {
        lineHeight: "tall",
        pb: 8,
        spacing: 4,
        children: /*#__PURE__*/_jsx(ReactMarkdown, {
          children: (_data$about2 = data.about) === null || _data$about2 === void 0 ? void 0 : _data$about2.preface,
          components: baseComponents
        })
      }), /*#__PURE__*/_jsx(SimpleGrid, {
        columns: [2, 3, 4],
        gap: 4,
        children: (_data$about3 = data.about) === null || _data$about3 === void 0 ? void 0 : (_data$about3$knowledg = _data$about3.knowledgeBases) === null || _data$about3$knowledg === void 0 ? void 0 : _data$about3$knowledg.map(function (kb) {
          var _kb$entries;

          return kb && /*#__PURE__*/_jsxs(Box, {
            children: [/*#__PURE__*/_jsx(Heading, {
              pb: 4,
              size: "md",
              children: kb.title
            }), /*#__PURE__*/_jsx(List, {
              fontSize: "sm",
              spacing: 1,
              children: (_kb$entries = kb.entries) === null || _kb$entries === void 0 ? void 0 : _kb$entries.split(", ").map(function (e, i) {
                return /*#__PURE__*/_jsx(ListItem, {
                  children: e.trim()
                }, i);
              })
            })]
          }, kb.title);
        })
      }), /*#__PURE__*/_jsx(Box, {
        h: 8
      }), /*#__PURE__*/_jsxs(Text, {
        pb: 2,
        children: ["You can reach out via email at", " ", /*#__PURE__*/_jsx(Link, {
          href: "mailto:".concat(meta.about.email),
          variant: variant,
          children: meta.about.email
        }), ", or via socials below:"]
      }), /*#__PURE__*/_jsx(List, {
        spacing: 1,
        children: Object.entries(meta.about.socialsJson).map(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              name = _ref2[0],
              href = _ref2[1];

          return /*#__PURE__*/_jsxs(ListItem, {
            children: [name, " -", " ", /*#__PURE__*/_jsx(Link, {
              href: href,
              isExternal: true,
              variant: variant,
              children: trimHttps(href)
            })]
          }, name);
        })
      })]
    })]
  });
};

export var __N_SSG = true;
export default AboutPage;